// React Imports
import React, {Component} from "react";
import Gallery from 'react-grid-gallery';
import {images} from "../constants";

export default class HomeDetail extends Component {
    render() {
        return <div className="container">
            <Gallery images={images.reverse()}
                     enableImageSelection={false}
                     backdropClosesModal={true}
                     rowHeight={300}/>
        </div>
    }

}



/** WEBPACK FOOTER **
 ** ./src/components/HomeDetail.js
 **/